var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"width-1 a"},[_c('div',{staticClass:"height-3 py-2 box_size d-flex a-center j-start fang",staticStyle:{"position":"relative"}},[_c('span',{ref:"title",staticStyle:{"font-size":"15px"}},[_vm._v(_vm._s(_vm.headerText))]),_c('div',{staticClass:"aaaaaa",style:({width: _vm.operatewidth + 'px' 
     }),attrs:{"id":"line"}})]),_c('el-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }